import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useOverviewRoute} from './use-overview-route'

export const useAssigneesQuery = () => useRouteQuery(useOverviewRoute(), 'assignees')

export const useAssigneesQueryKey = () => useRouteQueryKey(useOverviewRoute(), 'assignees')

export const useReviewRequestsQuery = () => useRouteQuery(useOverviewRoute(), 'review_requests')

/** Reads the review requests query key without subscribing to the query itself. */
export const useReviewRequestsQueryKey = () => useRouteQueryKey(useOverviewRoute(), 'review_requests')

export const useDevelopmentQuery = () => useRouteQuery(useOverviewRoute(), 'development')

/** Reads the development query key without subscribing to the query itself. */
export const useDevelopmentQueryKey = () => useRouteQueryKey(useOverviewRoute(), 'development')

export const useLabelsQuery = () => useRouteQuery(useOverviewRoute(), 'labels')

export const useLabelsQueryKey = () => useRouteQueryKey(useOverviewRoute(), 'labels')

export const useParticipantsQuery = () => useRouteQuery(useOverviewRoute(), 'participants')

/** Automatically observes for live updates. */
export const useDeploymentsQuery = () => {
  const query = useRouteQuery(useOverviewRoute(), 'deployments')

  const aliveChannel = query.data?.aliveChannel ?? ''
  useInvalidateOnAliveUpdate(aliveChannel, query.queryKey)

  return query
}
